// A form's date field with Stride's own calendar (DatePopover) in place of
// the browser's: the browser's picker writes a date into the field the moment
// its month or year is changed. It looks like the form's other inputs (pass
// the same className); one click opens the calendar, a day click fills it.

import { useState } from 'react';
import DatePopover from '@modules/database/work-items/frontend/editors/DatePopover';

const fmt = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

// `value` 'YYYY-MM-DD' | '' | null; `onChange(iso | '')`.
export default function DateField({ value, onChange, disabled = false, className, style, placeholder = 'dd/mm/yyyy' }) {
  const [rect, setRect] = useState(null);
  return (
    <>
      <button type="button" className={className} disabled={disabled}
        onClick={(e) => { e.stopPropagation(); setRect(e.currentTarget.getBoundingClientRect()); }}
        style={{ textAlign: 'left', cursor: disabled ? 'default' : 'pointer', ...style }}>
        {fmt(value) || <span style={{ opacity: 0.5 }}>{placeholder}</span>}
      </button>
      {rect && <DatePopover anchor={rect} value={value || ''} zIndex={4300} onClose={() => setRect(null)} onPick={(v) => onChange(v || '')} />}
    </>
  );
}
